import * as intercom from '@anm/helpers/intercom';
import isInIframe from '@anm/helpers/is/isInIframe';
import { compose, hoistStatics, lifecycle, InferableComponentEnhancer } from 'recompose';
import { User } from 'user';

import vtConfig from '../config';

import withAppMeta, { WithAppMetaProps } from './withAppMeta';
import withAuth, { WithAuth } from './withAuth';
import withUser, { WithUserProps } from './withUser';

type HOCs = WithAuth & WithUserProps & WithAppMetaProps;

const getCanLoadIntercom = () => !isInIframe();

const updateIntercom = (profile: User | null, isPrevLogged = false) => {
  const { setUser, isInit, setAnonymous } = intercom;

  if (!isPrevLogged && profile) {
    setUser(profile);
  }

  if ((isPrevLogged && !profile) || !isInit) {
    setAnonymous({ hide_default_launcher: false });
  }
};

const { intercom: intercomConfig } = vtConfig().support;
function componentDidMount(this: { props: HOCs }) {
  const {
    user: { profile },
    appMeta: { product }
  } = this.props;

  const { ids, enable } = intercomConfig;
  const canLoadIntercom = enable && getCanLoadIntercom();

  if (!canLoadIntercom) return;

  intercom.load();
  intercom.init(ids![product]);

  updateIntercom(profile, !!profile);
}

function componentDidUpdate(this: { props: HOCs }, { user: { profile: prevProfile } }: HOCs) {
  const {
    user: { profile }
  } = this.props;
  const canLoadIntercom = intercomConfig.enable && getCanLoadIntercom();

  if (!canLoadIntercom) return;

  updateIntercom(profile, !!prevProfile);
}

const WithSupport = compose(
  withAuth,
  withUser,
  withAppMeta,
  lifecycle<HOCs, {}>({ componentDidMount, componentDidUpdate })
) as InferableComponentEnhancer<{}>;

export default hoistStatics(WithSupport);
